import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { ProductReveal } from './components/ProductReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UpsellSection } from './components/UpsellSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // SEO: Set lang attribute
    document.documentElement.lang = 'es';
    // SEO: Add meta description
    if (!document.querySelector('meta[name="description"]')) {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'PROTORRENDA 4-12 — El método de los 4 pilares para el ciclista amateur argentino. 6 tomos + 2 bonos. Sistema de entrenamiento progresivo para mejorar tu rendimiento en subidas, pelotón y resistencia.';
      document.head.appendChild(meta);
    }
    // SEO: Add meta viewport if missing
    if (!document.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement('meta');
      viewport.name = 'viewport';
      viewport.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(viewport);
    }
    // SEO: Set page title
    document.title = 'PROTORRENDA 4-12 — Método de Entrenamiento para Ciclistas Amateurs';
    // Performance: Defer Meta Pixel loading to after page is interactive
    const loadPixel = () => {
      const script = document.createElement('script');
      script.async = true;
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '904978025482552');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      // Noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
      img.alt = '';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    };
    // Delay pixel load to improve LCP/FCP
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 2000);
    }
  }, []);
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-amber-500/30 selection:text-amber-200 scroll-smooth" data-id="element-0">
      <a href="#pricing" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-amber-500 focus:text-slate-950 focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-1">
        Ir al contenido principal
      </a>
      <main className="flex flex-col w-full overflow-x-hidden" role="main" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <TruthSection data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <TomosSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <ComparisonTable data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <UpsellSection data-id="element-11" />
        <PricingSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}